import script from "./RealityCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./RealityCheck.vue?vue&type=script&setup=true&lang=js"

import "./RealityCheck.vue?vue&type=style&index=0&id=3771d088&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3771d088"]])

export default __exports__